import React from "react";
import BillingWelcomeNotice from "../../components/BillingWelcomeNotice";

const AddAccountModal = () => {
  return (
    <div className="space-y-3 py-3 text-gray-600 text-sm">
      <p className="m-0">
        Connecting another organization may add a new backup subscription to
        your account. Each organization is billed separately.
      </p>
      <BillingWelcomeNotice variant="compact" />
    </div>
  );
};

export default AddAccountModal;
